import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import { LoadingBarComponent } from './loading-bar.component';
import { LoadingBarService } from './loading-bar.service';
@NgModule({
  imports: [
    CommonModule,
    SlimLoadingBarModule.forRoot()
  ],
  exports: [SlimLoadingBarModule, LoadingBarComponent],
  declarations: [LoadingBarComponent],
  providers: [LoadingBarService]
})
export class LoadingBarModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/loading-bar/loading-bar.module.ts